export const ADD_B2CSettings = 'ADD_B2CSettings';


export const addB2CSettings = B2CSettings => ({
    type: ADD_B2CSettings,
    payload: { B2CSettings }
});
